import apiFetch from '../apiFetch'

export default function (documentId, token, lastAccessDate) {
  return apiFetch({ endPoint: `document/${documentId}/cancelfleets`, method: 'PUT', token: token, lastAccessDate })
}
